export default __webpack_public_path__ + "static/media/Give Credit_Dark2.0fa3b7a3.svg";